<template>
  <div class="contentArea">
    <base-dialog :show="displayDelete" small>
      <div class="mx-5 my-5">
        <h4 class="text-white">ยืนยันการลบTaskนี้</h4>
        <div class="grid grid-cols-12 gap-4 mt-20">
          <vs-button
            class="col-end-9 col-span-4"
            color="#ffffff"
            text-color="#8d9498"
            @click="displayDelete = false"
            >ยกเลิก</vs-button
          >
          <vs-button
            class="col-end-13 col-span-4"
            color="#15c1c3"
            @click="confirmDeleteTask"
            >ยืนยัน</vs-button
          >
        </div>
      </div>
    </base-dialog>
    <base-dialog :show="displayImport" small>
      <form @submit.prevent="importTask">
        <h3 class="text-white text-center mb-5">
          กรุณาเลือกชื่อลูกค้า ที่ต้องการนำเข้า Task
        </h3>
        <div class="flex justify-center items-baseline mb-4">
          <h4 class="text-white mr-2">ชื่อลูกค้า :</h4>
          <select class="member-select" v-model="importToId" required>
            <option
              v-for="member in companyList"
              :key="member.detail_id"
              :value="member.detail_id"
              >{{ member.company_name }}</option
            >
          </select>
        </div>
        <div class="flex justify-center">
          <div
            v-if="!importedFile"
            class="grid import-file text-center items-center"
          >
            <label for="file">
              <font-awesome-icon
                class="mb-2"
                icon="file-upload"
                :style="{ color: '#ffffff' }"
                size="3x"
              />
              <p class="text-white">เพิ่มเอกสาร</p>
            </label>
          </div>
          <div v-else class="grid import-file text-center items-center">
            <label for="file">
              <font-awesome-icon
                class="mb-2"
                icon="file-alt"
                :style="{ color: '#ffffff' }"
                size="3x"
              />
              <p class="file-name ml-1">{{ importedFile.name }}</p>
            </label>
          </div>
        </div>
        <div class="grid grid-cols-12 gap-x-3 mt-4">
          <vs-button
            class="col-start-3 col-span-4"
            color="#ffffff"
            text-color="#8d9498"
            @click="clearImport"
            >ยกเลิก</vs-button
          >
          <vs-button
            class="col-start-7 col-span-4"
            color="#15c1c3"
            button="submit"
            >ยืนยัน</vs-button
          >
        </div>
      </form>
    </base-dialog>
    <div class="pl-2">
      <div>
        <!-- <topTableButton /> -->
        <div class="flex">
          <!-- <tabComponent /> -->
          <div v-if="true" class="company-container">
            <div class="search-stick">
              <input type="text" placeholder="Search" v-model="companyQuery" />
            </div>
            <!-- <div
              v-if="filteredCompany.length === 0"
              class="company-item text-center"
            >
              ไม่พบผลลัพท์
            </div> -->
            <div
              class="company-item"
              :class="{
                'selected-company': !selectedCompany.id,
              }"
              @click="
                setCompany({
                  name: null,
                  id: null,
                })
              "
            >
              ALL
            </div>
            <div
              class="company-item"
              v-for="company in filteredCompany"
              :key="company.detail_id"
              :class="{
                'selected-company': company.detail_id === selectedCompany.id,
              }"
              @click="
                setCompany({
                  name: company.company_name,
                  id: company.detail_id,
                })
              "
            >
              {{ company.company_name }}
            </div>
          </div>
          <div class="w-full">
            <div class="flex justify-between ml-3 date-filter">
              <div class="flex items-center" v-if="selectedCompany.id">
                <p>เดือน</p>
                <select class="date-select" v-model="monthSelected">
                  <option value="0">ALL</option>
                  <option
                    v-for="(month, index) in monthList"
                    :key="month"
                    :value="index + 1"
                  >
                    {{ month }}
                  </option>
                </select>
                <p>ปี</p>
                <select class="date-select" v-model="yearSelected">
                  <option value="ALL">ALL</option>
                  <option v-for="year in yearList" :key="year" :value="year">
                    {{ year }}
                  </option>
                </select>
                <p><nobr>ที่ให้บริการ (service month)</nobr></p>
              </div>
              <div class="flex items-center filter-input" v-else>
                <label class="mr-3">Start Date:</label>
                <div class="col-span-4 mr-5">
                  <v-date-picker
                    class="date-picker w-full"
                    is-dark
                    v-model="exportStartDate"
                    @dayclick="loadFilteredAllTask"
                  >
                    <template v-slot="{ inputEvents }">
                      <div class="date w-full">
                        <input
                          type="button"
                          class="date-input w-full text-left"
                          v-on="inputEvents"
                          :value="formattedExportStartDate"
                        />
                      </div>
                    </template>
                  </v-date-picker>
                </div>
                <label class="mr-3">End Date:</label>
                <div class="col-span-4 mr-5">
                  <v-date-picker
                    class="date-picker w-full"
                    is-dark
                    :min-date="exportStartDate"
                    v-model="exportEndDate"
                    @dayclick="loadFilteredAllTask"
                  >
                    <template v-slot="{ inputEvents }">
                      <div class="date w-full">
                        <input
                          type="button"
                          class="date-input w-full text-left"
                          v-on="inputEvents"
                          :value="formattedExportEndDate"
                        />
                      </div>
                    </template>
                  </v-date-picker>
                </div>
                <vs-button
                  color="#ffffff"
                  text-color="#8d9498"
                  @click="resetFilter"
                  v-if="exportStartDate && exportEndDate"
                  >รีเซ็ต
                </vs-button>
              </div>
              <div class="flex justify-end flex-wrap">
                <vs-button
                  class="mr-3 mt-3 px-px"
                  color="#69d8d1"
                  style="width: 100px;"
                  @click="exportExcel"
                >
                  Export
                </vs-button>
                <vs-button
                  v-if="permission.task_create && selectedCompany.id"
                  color="#03A9F3"
                  class="mr-3 mt-3 px-px"
                  style="width: 160px;"
                  @click="displayImport = true"
                >
                  <font-awesome-icon icon="file-import" class="mr-1" />
                  นำเข้าด้วย Excel
                </vs-button>
                <input
                  type="file"
                  accept=".xlsx, .xls, .csv"
                  id="file"
                  style="display: none"
                  ref="fileInput"
                  @change="onSelectFile($event)"
                />
                <vs-button
                  v-if="permission.invoice_create && selectedCompany.id"
                  color="#cebd25"
                  class="mr-3 mt-3 px-px"
                  style="width: 140px;"
                  @click="goToCreateInvoice"
                >
                  <font-awesome-icon icon="file-invoice-dollar" class="mr-1" />
                  ออกใบแจ้งหนี้
                </vs-button>
                <vs-button
                  v-if="permission.task_create && selectedCompany.id"
                  color="#15c1c3"
                  class="mr-3 mt-3 px-px"
                  style="width: 130px;"
                  @click="goToCreateTask"
                >
                  <font-awesome-icon icon="plus" class="mr-1" />
                  เพิ่ม Task
                </vs-button>
              </div>
            </div>
            <AgGrid ref="taskTable" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import topTableButton from "../views/elements/topTableButton/topTableButton";
// import tableOnly from "../views/elements/ag-grid-table/table_component/tableOnly";
import AgGrid from "./elements/ag-grid-table/AgGridTable";
// import tabComponent from "./elements/tabComponent/tabComponent";
// import boardMain from "./elements/board/boardMain";
import axios from "axios";
import moment from "moment";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import baseUrl from "../util/backend.js";
export default {
  data() {
    return {
      displayDelete: false,
      displayImport: false,
      importToId: null,
      importedFile: null,
      monthSelected: 0,
      yearSelected: new Date().getFullYear(),
      companyQuery: "",
      companyList: [],
      monthList: [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ],
      yearList: [
        "2015",
        "2016",
        "2017",
        "2018",
        "2019",
        "2020",
        "2021",
        "2022",
        "2023",
        "2024",
        "2025",
        "2026",
        "2027",
        "2028",
        "2029",
        "2030",
        "2031",
        "2032",
        "2033",
        "2034",
        "2035",
        "2036",
        "2037",
        "2038",
        "2039",
        "2040",
      ],
      deleteId: null,
      // for export task
      exportStartDate: null,
      exportEndDate: null,
    };
  },
  computed: {
    ...mapGetters({ nowSlug: "getNowSlug", tabActive: "general/tabActive" }),
    permission() {
      return this.$store.getters.getPermission;
    },
    filteredCompany() {
      return this.companyList.filter((com) =>
        com.company_name.toLowerCase().includes(this.companyQuery.toLowerCase())
      );
    },
    selectedCompany() {
      return this.$store.getters["create/getCompanyName"];
    },
    formattedExportStartDate() {
      if (this.exportStartDate) {
        return moment(this.exportStartDate).format("DD/MM/YYYY");
      } else {
        return null;
      }
    },
    formattedExportEndDate() {
      if (this.exportEndDate) {
        return moment(this.exportEndDate).format("DD/MM/YYYY");
      } else {
        return null;
      }
    },
  },
  components: {
    topTableButton,
    // tabComponent,
    // boardMain,
    AgGrid,
  },
  methods: {
    async importTask() {
      if (this.importedFile) {
        const formData = new FormData();
        formData.append("file", this.importedFile.file);
        formData.append("detail_id", this.importToId);
        const res = await axios.post(`${baseUrl}/task/import`, formData, {
          headers: {
            Authorization: this.$store.getters.getToken,
          },
        });
        console.log(res);
        this.clearImport();
        this.loadTable();
      } else {
        alert("กรุณาเลือกไฟล์");
      }
    },
    clearImport() {
      this.importToId = null;
      this.importedFile = null;
      this.displayImport = false;
    },
    async confirmDeleteTask() {
      const res = await axios.post(
        `${baseUrl}/task/delete?task_id=${this.deleteId}`,
        {},
        {
          headers: {
            Authorization: this.$store.getters.getToken,
          },
        }
      );
      this.loadTable();
      this.displayDelete = false;
    },
    goToCreateTask() {
      this.$router.push("/createtask");
    },
    goToCreateInvoice() {
      const selectedRow = this.$refs.taskTable.getSelectedRowData();
      if (selectedRow.length > 0) {
        this.$store.dispatch("create/setSelectedTask", selectedRow);
        this.$router.push("/createinvoice");
      } else {
        alert("กรุณาเลือกTaskก่อนสร้างInvoice");
      }
    },
    setCompany(name) {
      this.$store.dispatch("create/setCompanyName", name);
      if (name.id) {
        this.loadTable();
      } else {
        this.$store.dispatch("general/getExportTask", {
          from: this.exportStartDate,
          to: this.exportEndDate,
        });
      }
    },
    loadFilteredAllTask() {
      if (this.exportStartDate && this.exportEndDate) {
        this.$store.dispatch("general/getExportTask", {
          from: this.exportStartDate,
          to: this.exportEndDate,
        });
      }
    },
    resetFilter() {
      this.exportStartDate = "";
      this.exportEndDate = "";
      this.$store.dispatch("general/getExportTask", {
        from: this.exportStartDate,
        to: this.exportEndDate,
      });
    },
    onSelectFile(e) {
      // console.log(e.target.files[0]);
      // console.log(e.target.value.split(/(\\|\/)/g).pop());
      this.importedFile = {
        name: e.target.value.split(/(\\|\/)/g).pop(),
        file: e.target.files[0],
      };
    },
    loadTable() {
      let sendMonth = null;
      if (this.monthSelected < 10) {
        sendMonth = `0${this.monthSelected}`;
      } else {
        sendMonth = this.monthSelected;
      }
      // this.$store.dispatch("create/setTaskDate", {
      //   month: sendMonth,
      //   year: this.yearSelected,
      // });
      this.$store.dispatch("general/getFilteredTaskTable", {
        path: this.tabActive.path || this.nowSlug,
        month: sendMonth,
        year: this.yearSelected,
      });
    },
    async loadData() {
      const companies = await axios.get(`${baseUrl}/member/get`, {
        headers: {
          Authorization: this.$store.getters.getToken,
        },
      });
      this.companyList = companies.data.data;
      console.log(this.companyList);
      if (!this.selectedCompany.id) {
        this.setCompany({
          name: null,
          id: null,
        });
      } else {
        this.setCompany({
          name: this.selectedCompany.name,
          id: this.selectedCompany.id,
        });
      }
    },
    async exportExcel() {
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const exportToCSV = (apiData, fileName) => {
        const wscols = [
          { wch: 15 },
          { wch: 20 },
          { wch: 40 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 60 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
        ];
        let ws = XLSX.utils.json_to_sheet(apiData);
        ws["!cols"] = wscols;
        ws.A1.v = "วันที่";
        ws.B1.v = "Task no.";
        ws.C1.v = "รายละเอียด";
        ws.D1.v = "เดือน/ปี ที่ให้บริการ";
        ws.E1.v = "ชื่อบริษัท";
        ws.F1.v = "จำนวนเงิน";
        ws.G1.v = "ภาษีหัก ณ ที่จ่าย";
        ws.H1.v = "ยอดสุทธิ";
        ws.I1.v = "หมายเหตุ";
        ws.J1.v = "สถานะ";
        if (this.selectedCompany.id) {
          ws.K1.v = "";
          ws.L1.v = "";
        } else {
          ws.K1.v = "Invoice Ref.";
          ws.L1.v = "Receipt Ref.";
        }
        // console.log(ws);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
      };
      if (this.selectedCompany.id) {
        const dataPDF = [];
        let sendMonth = null;
        if (this.monthSelected < 10) {
          sendMonth = `0${this.monthSelected}`;
        } else {
          sendMonth = this.monthSelected;
        }
        let taskData = null;
        if (this.yearSelected === "ALL") {
          const response = await axios.get(`${baseUrl}/admin/getTable`, {
            headers: {
              Authorization: this.$store.getters.getToken,
            },
            params: {
              path: this.tabActive.path || this.nowSlug,
              detail_id: this.selectedCompany.id,
            },
          });
          taskData = response.data.data.data;
        } else {
          const response = await axios.get(`${baseUrl}/admin/getTable`, {
            headers: {
              Authorization: this.$store.getters.getToken,
            },
            params: {
              path: this.tabActive.path || this.nowSlug,
              detail_id: this.selectedCompany.id,
              month_service: sendMonth,
              year_service: this.yearSelected,
            },
          });
          taskData = response.data.data.data;
        }
        console.log(taskData);
        if (taskData.length === 0) {
          alert("ไม่มีข้อมูล");
          return;
        }
        for (const task of taskData) {
          dataPDF.push({
            A: moment(task.date_createdAt).format("DD/MM/YYYY"),
            B: task.task_code,
            C: task.task_name,
            D: moment(task.date).format("MM/YYYY"),
            E: task.company_name,
            F: task.price,
            G: task.tax ? task.tax : "",
            H: task.net,
            I: task.note,
            J: task.task_status,
            K: task.invoice_code,
            L: task.receipt_code,
          });
        }
        exportToCSV(
          dataPDF,
          `Task_${this.selectedCompany.name}_${
            sendMonth === "00"
              ? this.yearSelected
              : `${sendMonth}-${this.yearSelected}`
          }`
        );
      } else {
        if (
          (this.exportStartDate && !this.exportEndDate) ||
          (!this.exportStartDate && this.exportEndDate)
        ) {
          alert("กรุณาระบุวันที่เริ่มต้นและสิ้นสุด");
          return;
        }
        const dataPDF = [];
        let taskData = null;
        const response = await axios.get(`${baseUrl}/admin/getTable`, {
          headers: {
            Authorization: this.$store.getters.getToken,
          },
          params: {
            path: "exportTask",
            from: this.exportStartDate,
            to: this.exportEndDate,
          },
        });
        taskData = response.data.data.data;

        console.log(taskData);
        if (taskData.length === 0) {
          alert("ไม่มีข้อมูล");
          return;
        }
        for (const task of taskData) {
          dataPDF.push({
            A: moment(task.date_createdAt).format("DD/MM/YYYY"),
            B: task.task_code,
            C: task.task_name,
            D: moment(task.date).format("MM/YYYY"),
            E: task.company_name,
            F: task.price,
            G: task.tax ? task.tax : "",
            H: task.net,
            I: task.note,
            J: task.task_status,
            K: task.invoice_code,
            L: task.receipt_code,
          });
        }
        exportToCSV(
          dataPDF,
          `ALL_Task${
            this.exportStartDate
              ? `_${moment(this.exportStartDate).format("DD-MM-YYYY")}_${moment(
                  this.exportEndDate
                ).format("DD-MM-YYYY")}`
              : ""
          }`
        );
      }
    },
  },
  mounted() {
    this.$root.$on("delete-modal", (id) => {
      this.displayDelete = true;
      this.deleteId = id;
    });
    // this.$store.dispatch("general/getFilteredTaskTable", {
    //   path: this.tabActive.path || this.nowSlug,
    //   month: "00",
    //   year: this.yearSelected,
    // });
  },
  watch: {
    yearSelected() {
      if (this.yearSelected === "ALL") {
        this.monthSelected = 0;
      }
      this.loadTable();
    },
    monthSelected() {
      if (this.monthSelected !== 0) {
        this.yearSelected = new Date().getFullYear();
      }
      this.loadTable();
    },
    tabActive(newValue) {
      this.$store.dispatch("general/getTable", newValue.path);
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style scoped>
label {
  cursor: pointer;
}

.member-select {
  background: #4e5363;
  border: none;
  color: #dddddd;
  font-size: 17px;
  padding: 6px 10px;
  width: 80%;
}

.import-file {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #4e5363;
  border-radius: 5px;
  width: 109.5px;
  height: 109.5px;
  cursor: pointer;
}

.file-name {
  color: #fff;
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.company-container {
  position: relative;
  background: #4e5363;
  width: 25%;
  height: 100vh;
  border: 1px solid #393e50;
  margin: -35px 0 0 -24px;
  overflow-y: auto;
}

.search-stick {
  position: sticky;
  position: -webkit-sticky;
  top: 0; /* required */
}

input[type="text"] {
  width: 100%;
  border: 15px solid #4e5363;
  border-radius: 2px;
  background-color: #3a3f51;
  color: #dddddd;
  padding: 10px 5px;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #dddddd;
  opacity: 1; /* Firefox */
}

.company-item {
  font-size: 16px;
  color: #dddddd;
  padding: 12px 15px;
  border-bottom: 1px solid #393e50;
  cursor: pointer;
  transition: 0.3s;
}
.company-item:hover {
  background-color: rgba(255, 255, 255, 0.096);
}

.date-select {
  background: #4e5363;
  border: none;
  color: #dddddd;
  font-size: 17px;
  margin-right: 30px;
  padding: 6px 10px;
  width: 100px;
}

.date-filter {
  color: #dddddd;
}

.date-filter p {
  font-size: 18px;
  margin-right: 10px;
}

.filter-input input[type="button"] {
  display: block;
  height: 38px;
  min-width: 120px;
  border-radius: 5px;
  background: #4e5363;
  border: none;
  color: #ffffff;
  font-size: 17px;
  padding: 5px 10px;
}

.selected-company {
  background-color: #15c1c3;
}

.selected-company:hover {
  background-color: #15c1c3;
}

.search-stick ::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-size: 16px;
  opacity: 1; /* Firefox */
}
</style>
